import { cn } from '../../lib/utils.js';

interface LogoProps {
  className?: string;
  onClick?: () => void;
}

export const Logo = ({ className, onClick }: LogoProps) => {
  return (
    <h1
      onClick={onClick}
      className={cn('font-poppins font-bold tracking-wide text-xl text-white cursor-pointer select-none', className)}
    >
      gradias
    </h1>
  );
};
